import l from '../../../../../lang';
import { ReactComponent as FileIcon } from '../../../../../assets/icons/file.svg';
import { TransactionTaxes } from '../../../../../store/transactions/interfaces';
import TransactionDetailSection from '../transaction-detail-section';
import { formatTaxAmount, formatTaxPercentage } from './taxes-utils';

interface TaxesAndRetentionsSectionProps {
  taxes?: TransactionTaxes | null;
}

const TaxesAndRetentionsSection = ({ taxes }: TaxesAndRetentionsSectionProps) => {
  if (!taxes?.taxes?.length) {
    return null;
  }

  return (
    <TransactionDetailSection
      title={l('transactions.taxesAndRetentions')}
      icon={<FileIcon className="transaction_detail__title_section__icon" aria-hidden />}
      defaultExpanded
    >
      <p className="transaction_detail__taxes__description">{l('transactions.taxesAndRetentions.description')}</p>
      <table className="transaction_detail__taxes__table">
        <thead>
          <tr>
            <th>{l('transactions.taxesAndRetentions.descriptionColumn')}</th>
            <th>%</th>
            <th className="transaction_detail__taxes__table__amount">{l('transactions.taxesAndRetentions.amountColumn')}</th>
          </tr>
        </thead>
        <tbody>
          {taxes.taxes.map((tax, index) => (
            <tr key={`${tax.description}-${index}`}>
              <td>{tax.description || '-'}</td>
              <td>{formatTaxPercentage(tax.percentage)}</td>
              <td className="transaction_detail__taxes__table__amount">
                {formatTaxAmount(taxes.taxesCurrency, tax.amount, Boolean(tax.withholding))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </TransactionDetailSection>
  );
};

export default TaxesAndRetentionsSection;
